// extracted by mini-css-extract-plugin
export default {"cardsContainer":"CardsList_cardsContainer__hy0O1"};